// extracted by mini-css-extract-plugin
export var askAiIcon = "_ol-9";
export var container = "_ol-0";
export var groupSeparator = "_ol-a";
export var highlight = "_ol-4";
export var resultIcon = "_ol-5";
export var resultItem = "_ol-7";
export var resultSubtitle = "_ol-3";
export var resultTitle = "_ol-2";
export var resultsList = "_ol-1";
export var searchGroup = "_ol-6";
export var selected = "_ol-8";